"use client";

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        initData?: string;
        colorScheme?: "light" | "dark";
        themeParams?: {
          bg_color?: string;
          secondary_bg_color?: string;
          header_bg_color?: string;
        };
        setHeaderColor?: (color: string) => void;
        setBackgroundColor?: (color: string) => void;
        onEvent?: (event: string, callback: (payload?: unknown) => void) => void;
        offEvent?: (event: string, callback: (payload?: unknown) => void) => void;
        requestContact?: (callback?: (shared: boolean) => void) => void;
        openTelegramLink?: (url: string) => void;
        openLink?: (url: string, options?: { try_instant_view?: boolean }) => void;
        ready?: () => void;
      };
    };
  }
}

function telegramInitData(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const fromTelegram = window.Telegram?.WebApp?.initData;
  if (fromTelegram) return fromTelegram;

  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  const params = new URLSearchParams(hash);
  return params.get("tgWebAppData") ?? undefined;
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  const isFormData = typeof FormData !== "undefined" && init?.body instanceof FormData;
  if (!headers.has("Content-Type") && init?.body && !isFormData) {
    headers.set("Content-Type", "application/json");
  }
  const initData = telegramInitData();
  if (initData) {
    headers.set("Authorization", `tma ${initData}`);
  }

  const response = await fetch(path, {
    ...init,
    headers,
    credentials: "include",
  }).catch((error: unknown) => {
    const message =
      error instanceof TypeError
        ? `Failed to fetch (${error.message || "network"})`
        : error instanceof Error
          ? error.message
          : "Failed to fetch";
    throw new Error(message);
  });

  const payload = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok) {
    throw new Error(payload.error || `Не вдалося виконати запит (${response.status}).`);
  }
  return payload;
}

export async function apiBinary(path: string): Promise<Blob> {
  const headers = new Headers();
  const initData = telegramInitData();
  if (initData) {
    headers.set("Authorization", `tma ${initData}`);
  }
  const response = await fetch(path, { headers, credentials: "include" });
  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as { error?: string };
    throw new Error(payload.error || "Не вдалося завантажити файл.");
  }
  return response.blob();
}
